import React from "react";
import "../../assets/css/loader.css";

const Loader = () => {
  return (
    <div className="idp_Loader">
        <div id="bowlG">
            <div id="bowl_ringG">
                <div className="ball_holderG">
                    <div className="ballG"></div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default Loader;
